// extracted by mini-css-extract-plugin
export default {"zoomControls":"nda-z","zoomControlButton":"oda-z","zoomBanner":"pda-z","bannerButton":"qda-z","imageButton":"rda-z","zoom":"sda-z","zoomContent":"tda-z"};